import React from 'react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { hasProperty } from '@gov-nx/core/types';
import type { PageCode } from '@gov-nx/module/page';
import {
	NastaveniKontaktniUdajeROSItemContextProvider,
	useNastaveniKontaktnichUdajuROSContext,
} from '@gov-nx/module/page';
import { ErrorStatusBanner, InfoBanner } from '@gov-nx/ui/web';
import { ContactListSkeleton } from '../Skeletons';
import { ROSContactView } from './ContactView';

interface ROSContactListViewProps {
	code: PageCode;
}

export const ROSContactListView = ({ code }: ROSContactListViewProps) => {
	const { rosContacts, initialState } =
		useNastaveniKontaktnichUdajuROSContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	if (initialState.isLoading) {
		return <ContactListSkeleton />;
	}

	if (initialState.error) {
		return <ErrorStatusBanner code={code} />;
	}

	const ts = getLocalizeCurried(code);

	if (rosContacts.length === 0) {
		return (
			<InfoBanner
				headline={ts('stav.chyba.nic-jsme-nenasli')}
				text={ts('stav.chyba.nenasli-jsme-zadne-udaje')}
			/>
		);
	}

	return (
		<ul className="gov-list--plain">
			{rosContacts.filter(hasProperty('ico')).map((contact) => (
				<li
					key={contact.ico}
					className="py-4">
					<NastaveniKontaktniUdajeROSItemContextProvider
						contact={contact}
						code={code}>
						<ROSContactView code={code} />
					</NastaveniKontaktniUdajeROSItemContextProvider>
				</li>
			))}
		</ul>
	);
};
